import { UILibrary } from '../consts/ui-library';
import Vue from 'vue';
import { DynamicSource, WujiScene, dynamicSourceManager } from './consumer';
import { getProjectInfo } from './util';
const importTDesignMessage = () => import(/* webpackChunkName: "t_design_message" */ 'tdesign-vue/es/message');
export const runtimeImportTDesignIfNeeded = async () => {
    const { project } = await getProjectInfo();
    if (project.componentHubUILibrary === UILibrary.tdesign) {
        // chunk name在webpack.default.config.js 有使用到
        const source = await import(/* webpackChunkName: "t_design" */ 'tdesign-vue');
        Vue.use(source);
        return source;
    }
};
const importerMap = {
    [WujiScene.Editor]: [{ name: DynamicSource.TDesignMessage, import: importTDesignMessage }],
    [WujiScene.Runtime]: [{ name: DynamicSource.TDesign, import: runtimeImportTDesignIfNeeded }],
};
export const importDynamicDepdencies = (scene) => {
    dynamicSourceManager.setScene(scene);
    const importers = importerMap[scene] ?? [];
    const importSet = new Set(importers.map(importer => importer.name));
    // 清空无依赖的回调
    dynamicSourceManager.getCurrentDependencies().forEach((key) => {
        const sourceName = key;
        if (!importSet.has(sourceName)) {
            dynamicSourceManager.clearCallback(sourceName, undefined);
        }
    });
    const loadingPromise = Promise.all(importers.map(importer => dynamicSourceManager.loadDynamicSource(importer)));
    return loadingPromise;
};
export const setWujiSceneForTest = (scene = WujiScene.Runtime) => {
    dynamicSourceManager.setScene(scene);
};
export * from './consumer';
export * from './util';
